import Layout from '@/layout'

const notice = {
  path: '/notice',
  name: 'NoticeList',
  component: Layout,
  title: '通知公告',
  redirect: '/notice',
  meta: { title: '通知公告', name: 'NoticeList', hidden: true },
  children: [
    {
      path: '',
      name: 'Notice',
      component: () => import('@/views/Notice/index.vue'),
      meta: { title: '活动预约', isShowSidebar: false, hidden: true }
    },
    {
      path: 'detail/:id',
      name: 'NoticeDetail',
      component: () => import('@/views/Notice/detail.vue'),
      meta: { title: '公告详情', hidden: true, isShowSidebar: false }
    }

  ]
}

export default notice
